import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './DeliveryDriverSelect.css';
import Input from '../../components/UI/Input/Input';


class DeliveryDriverSelect extends Component {
    state = {
        driverId: 0,
        driverSelected: false
    }

    driverSelected = ( event ) => {
        this.props.driverChanged(event.target.value);       
    }

    render () {
        if (this.props.drivers) {
            let option = [,];
            option.push({
                value: 0,
                displayValue: ""
            });
            for (let key in this.props.drivers) {

                if (this.props.drivers[key].status != 'unavailable') { 
                    option.push({
                        value: this.props.drivers[key].driverId,
                        displayValue: this.props.drivers[key].firstName + ' ' + this.props.drivers[key].lastName
                    });
                }
            }
            const options = {options: option};
            return (
                <div>
                    <Input value={this.props.driverId} label='Driver' elementType='select' elementConfig={options} changed={(event) => this.driverSelected(event)}></Input>
                </div>
            );
        }
    }
};

const mapStateToProps = state => {
 
    return {
        drivers: state.orders.drivers
    };
}


export default connect(mapStateToProps)(DeliveryDriverSelect);


// WEBPACK FOOTER //
// ./src/components/DeliveryDriverSelect/DeliveryDriverSelect.js